import { SimpleGrid, Stack, VStack } from "@chakra-ui/react";
import { EventDetailStatsSectionData } from "@common/interfaces/KYDEvent";
import { Stat } from "../../TicketSales/TicketSalesSection";

const StatsSection = ({ data }: { data: EventDetailStatsSectionData }) => {
  return (
    <VStack>
      <Stack w="100%" align={"flex-end"}>
        <SimpleGrid w="100%" columns={{ base: 1, md: 4 }} gap="6">
          {data?.stats &&
            data?.stats.map((stat) => (
              <Stat
                key={stat.title}
                label={stat.title}
                value={stat.value}
                height="80px"
              />
            ))}
        </SimpleGrid>
      </Stack>
    </VStack>
  );
};

export default StatsSection;
